export const CLIENTS_SET = "clientsSet";
export const CLIENT_SET = "clientSet";
export const CLIENTS_RESET = "clientsReset";
export const CLIENT_RESET = "clientReset";
export const SET_CLIENT_ACTIVE ='setClientActive'
export const SET_CLIENT_PAGINATION = 'setClientPagination'